import React from 'react';
import { motion } from 'framer-motion';
import { PurchaseToast } from './PurchaseToast';
import { CtaShimmer } from './CtaShimmer';
import { Zap, ShieldCheck } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-fit bg-transparent text-navy flex flex-col items-center justify-start md:justify-center px-4 pt-4 md:pt-16 pb-6 md:pb-12 overflow-hidden font-sans" data-id="element-131">
      {/* Background technical elements */}
      <div className="absolute top-10 left-10 text-slate-200 opacity-50 hidden md:block" data-id="element-132">
        <Zap size={120} strokeWidth={1} data-id="element-133" />
      </div>
      <div className="absolute bottom-20 right-10 text-slate-200 opacity-50 hidden md:block" data-id="element-134">
        <ShieldCheck size={120} strokeWidth={1} data-id="element-135" />
      </div>

      {/* Brand Header */}
      <div className="flex items-center gap-2 mb-2.5 md:mb-6 bg-white px-3 py-1.5 md:px-4 md:py-2 rounded border border-slate-200 shadow-sm" data-id="element-136">
        <div className="w-2 h-2 bg-electric rounded-full animate-pulse" data-id="element-137"></div>
        <span className="text-navy font-black tracking-widest text-[11px] md:text-sm uppercase" data-id="element-138">
          MEGA KIT ELECTRICISTA PRO™
        </span>
      </div>

      {/* Main Title */}
      <h1 className="text-[22px] md:text-6xl lg:text-7xl font-black text-center max-w-5xl mb-2 md:mb-6 text-navy leading-[1.15]" data-id="element-139">
        ELIGE UN OFICIO CON{' '}
        <span className="text-electric drop-shadow-sm" data-id="element-140">ALTA DEMANDA</span> EN
        LATAM
        <span className="text-slate-600 md:text-[22px] block mt-2.5 md:mt-4 text-[14px] font-semibold leading-snug max-w-2xl mx-auto normal-case" data-id="element-141">
          Con el MEGA KIT ELECTRICISTA PRO™, aprende electricidad práctica y
          empieza a generar de{' '}
          <span className="text-electric font-black" data-id="element-142">
            USD 1.000 a USD 3.000
          </span>{' '}
          trabajando por tu cuenta en{' '}
          <span className="text-electric font-black" data-id="element-143">menos de 30 días</span>.
        </span>
        <span className="text-slate-500 md:text-[16px] block mt-2 md:mt-3 text-[12px] font-medium leading-snug max-w-2xl mx-auto normal-case" data-id="element-144">
          +25 manuales, 100 video-clases y una biblioteca de diagramas para
          aprender desde celular, tablet o computadora.
        </span>
      </h1>

      {/* Product Visual Mockup */}
      <div className="relative w-full max-w-[210px] md:max-w-[520px] mb-4 md:mb-8" data-id="element-145">
        <div className="absolute inset-0 bg-navy rounded-xl transform rotate-2 scale-105 -z-10 opacity-5" data-id="element-146"></div>
        <img src="https://cdn.magicpatterns.com/uploads/scxrHoEmFJXbkQ88ujUNfn/ChatGPT-Image-30-jun-2026_-04_23_24-p.m..webp" alt="MEGA KIT ELECTRICISTA PRO™" width={1024} height={1024} loading="eager"
      // @ts-ignore
      fetchpriority="high" decoding="async" className="w-full h-auto max-h-[210px] md:max-h-none object-contain mix-blend-multiply rounded-lg border-2 border-slate-200 shadow-lg" data-id="element-147" />
      </div>

      {/* CTA Button */}
      <motion.button animate={{
      y: [0, -3, 0],
      boxShadow: ['0 6px 0 rgb(200,160,0), 0 0 0px rgba(255,210,0,0)', '0 6px 0 rgb(200,160,0), 0 0 22px rgba(255,210,0,0.55)', '0 6px 0 rgb(200,160,0), 0 0 0px rgba(255,210,0,0)']
    }} transition={{
      duration: 2.6,
      repeat: Infinity,
      ease: 'easeInOut'
    }} whileHover={{
      scale: 1.03,
      boxShadow: '0 6px 0 rgb(200,160,0), 0 0 34px rgba(255,210,0,0.75)'
    }} whileTap={{
      scale: 0.98
    }} onClick={() => document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    })} className="relative overflow-hidden w-full max-w-xs md:max-w-md bg-electric hover:bg-yellow-400 text-navy font-black text-lg md:text-2xl py-4 md:py-6 px-8 md:px-12 rounded flex items-center justify-center gap-3 transition-colors mb-2.5 md:mb-5 uppercase" data-id="element-148">
        <CtaShimmer data-id="element-149" />
        <span className="relative z-10 text-2xl" data-id="element-150">⚡</span>
        <span className="relative z-10 text-[16px] md:text-[20px]" data-id="element-151">
          QUIERO MI MEGA KIT PRO
        </span>
      </motion.button>

      {/* Guarantee Text */}
      <p className="text-[11px] md:text-sm text-slate-500 font-semibold mb-3 md:mb-8 text-center bg-white px-4 py-1.5 md:py-2 rounded border border-slate-200 shadow-sm" data-id="element-152">
        🔒 Garantía de satisfacción de 7 días.
      </p>

      {/* Trust Badges — secundarios: ocultos en mobile para priorizar el fold */}
      <div className="hidden sm:flex flex-wrap justify-center gap-3 md:gap-6 text-[10px] md:text-sm font-bold text-navy animate-fade-in" data-id="element-153">
        <div className="flex items-center gap-2 bg-white px-4 py-2 rounded border border-slate-200 shadow-sm" data-id="element-154">
          <span className="text-electric" data-id="element-155">📄</span> PDF + VIDEO
        </div>
        <div className="flex items-center gap-2 bg-white px-4 py-2 rounded border border-slate-200 shadow-sm" data-id="element-156">
          <span className="text-electric" data-id="element-157">⚡</span> ACCESO 24/7
        </div>
      </div>

      <PurchaseToast data-id="element-158" />
    </section>;
}